import React from 'react';
import { TTranslatesContext } from './types';
import { Language } from './enums';

const stub = () => {
  throw new Error('<TranslatesProvider> not found');
};

export const TranslatesContext = React.createContext<TTranslatesContext>({
  translates: {},
  setTranslates: stub,
  selectedLang: Language.ENGLISH,
  setSelectedLang: stub,
});
